export const sectionConfig = {
    suptitle: "داستان فیگ ای آی",
    title: "از دل محدودیت، ایده جان گرفت",
    caption: "همه چیز از دل یک چالش شروع شد: روزهایی که دسترسی به ابزارهای جهانی هوش مصنوعی برایمان سخت شده بود. ما در تیم «فیگ فیت»، فقط به تماشای این وضعیت ننشستیم. تصمیم گرفتیم آستین بالا بزنیم و با راه‌اندازی زیرساختی لوکال، پلی بزنیم به دنیای مدل‌های هوشمند.",
    caption2: "«فیگ ای آی» نه با رانت متولد شد و نه با شعارهای توخالی. ما از یک ایده ساده در یک محیط آزمایشی (MVP) شروع کردیم و تنها چیزی که داشتیم، اشتیاق برای ارائه سرویسی بود که کاربر واقعاً بتواند به آن اعتماد کند. ما اینجا هستیم تا بدون فریب دادن کاربر یا دست‌کاری در مدل‌ها، تجربه‌ای شفاف و کارآمد از هوش مصنوعی را برای شما رقم بزنیم.",
}

export type SectionConfig = typeof sectionConfig
